import { buffers, eventChannel } from "redux-saga";
export default class SocketChannel {
    static instance;
    channel;
    constructor() {
        if (SocketChannel.instance) {
            throw new Error("Instantiation failed: use SocketChannel.getInstance() instead of new");
        }
        else {
            SocketChannel.instance = this;
        }
    }
    static getInstance() {
        if (SocketChannel.instance) {
            return SocketChannel.instance;
        }
        return new SocketChannel();
    }
    createSocketChannel(socket, getCallbacks) {
        const buffer = buffers.expanding();
        this.channel = eventChannel((emitter) => {
            const { methods, reconnected, reconnecting, unlistenHistory, close } = getCallbacks(emitter);
            for (const method of Object.keys(methods)) {
                const callback = methods[method];
                socket.subscribeMethod(method, callback);
            }
            typeof reconnecting === "function" && socket.subscribeReconnectingHandler(reconnecting);
            typeof reconnected === "function" && socket.subscribeReconnectedHandler(reconnected);
            typeof close === "function" && socket.subscribeCloseHandler(close);
            return () => {
                for (const method of Object.keys(methods)) {
                    socket.unsubscribeMethod(method);
                }
                typeof unlistenHistory === "function" && unlistenHistory();
            };
        }, buffer);
    }
    getChannel() {
        return this.channel;
    }
}
